export const registerRcsTemplateMutation = (builder) => ({
  registerRcsTemplate: builder.mutation({
    query: (credentials) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/register_rcs_template",
        method: "POST",
        body: credentials,
        headers: {
          Authorization: token,
        },
      };
    },
  }),
});
